import {
  IGetIvideonRefreshTokenParams,
  IIvideonAuthSignature,
} from "~/services/ivideon/model";
import { destroyIvideonCredentials } from "~/services/ivideon/lib/tokenWorkers";

export const refreshTokenIvideon = async ({
  refresh_token,
}: IGetIvideonRefreshTokenParams) => {
  const response = await fetch("https://api.ivideon.com/auth/oauth/token", {
    method: "POST",
    body: new URLSearchParams({
      grant_type: "refresh_token",
      refresh_token: refresh_token,
      client_id: "autovaz_a2s",
    }),
  });

  if (response.ok) return (await response.json()) as IIvideonAuthSignature;
  else {
    console.log(await response.json(), "<");
    destroyIvideonCredentials();
    return "see error in console";
  }
};
